<template>
  <div id="app">
    <profile></profile>
  </div>
</template>

<script>
// OGP タグをサーバサイドで書き出すためにAppを個別に作成
import Profile from '@/pages/profile/index.vue'

export default {
  name: 'app',
  components: {
    Profile
  }
}
</script>

<style src="./app.css">
</style>
